import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s4};
    width: 100%;
    max-width: ${theme.sz.xs};

    @media (max-width: ${theme.sz.md}) {
      max-width: none;
      gap: ${theme.sz.s2};
    }
  `,
);

export const ContinueLabel = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.sz.s2};

    svg {
      width: ${theme.sz.s5};
      height: ${theme.sz.s5};
    }
  `,
);

export const TextButton = styled.button(
  ({ theme }) => css`
    ${theme.typography.button.s};
    padding: ${theme.sz.s1};
    border: 0;
    background: none;
    color: ${theme.co.neutral10};
    text-decoration: underline;
    text-underline-offset: ${theme.sz.s1};
    cursor: pointer;

    ${theme.focusVisible};
  `,
);

export const Row = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s4};
    width: 100%;
    max-width: ${theme.sz.md};
    margin: 0 auto;

    @media (max-width: ${theme.sz.md}) {
      max-width: none;
      gap: ${theme.sz.s3};
    }
  `,
);

export const DoneButton = styled.div`
  flex: 1 1 0;
`;

export const Primary = styled.div`
  flex: 2 1 0;
`;
